// Free version - simplified read-only Production Tracker
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import "../associate-tracker.css";

export default function FreeProductionTracker() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Get user email from URL params
  const userEmail = searchParams.get("user");

  useEffect(() => {
    const fetchData = async () => {
      if (!userEmail) {
        setLoading(false);
        return;
      }
      
      setLoading(true);
      try {
        // Find trackers by email
        const trackerData = await getDocs(
          query(collection(db, "trackers"), where("email", "==", userEmail))
        );
        if (!trackerData.empty) {
          const docData = trackerData.docs[0].data().associate;
          setData(docData);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userEmail]);

  const handleReset = () => {
    navigate("/production-tracker-free");
  };

  const personalPoints = data?.associate?.personalPoints || 0;
  const target = 45000;
  const progress = Math.min((personalPoints / target) * 100, 100);

  return (
    <div className="tracker-page">
      <div className="tracker-header">
        <h1>Production Tracker (View Only)</h1>
        <button className="reset-btn" onClick={handleReset}>
          Back
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="production-display">
          <h2>Personal Points Progress</h2>
          <div className="progress-section">
            <div className="big-number">{personalPoints.toLocaleString()}</div>
            <div className="progress-bar-container">
              <div className="progress-bar" style={{ width: `${progress}%` }}></div>
            </div>
            <div className="progress-label">
              {personalPoints.toLocaleString()} / {target.toLocaleString()} points
            </div>
            {personalPoints >= target ? (
              <div className="goal-achieved">🎉 Goal Achieved!</div>
            ) : (
              <div className="remaining">
                {(target - personalPoints).toLocaleString()} points remaining
              </div>
            )}
          </div>
        </div>
      )}

      <style>{`
        .production-display {
          padding: 40px;
          text-align: center;
        }
        .progress-section {
          max-width: 600px;
          margin: 30px auto;
        }
        .big-number {
          font-size: 64px;
          font-weight: bold;
          color: #ffd700;
          margin-bottom: 20px;
        }
        .progress-bar-container {
          width: 100%;
          height: 30px;
          background: rgba(0,0,0,0.2);
          border-radius: 15px;
          overflow: hidden;
          margin: 20px 0;
        }
        .progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #16a34a, #ffd700);
          transition: width 0.3s ease;
        }
        .progress-label {
          font-size: 18px;
          color: #fff;
          margin: 10px 0;
        }
        .goal-achieved {
          font-size: 24px;
          color: #16a34a;
          margin-top: 20px;
        }
        .remaining {
          font-size: 16px;
          color: #9fb0c7;
          margin-top: 10px;
        }
      `}</style>
    </div>
  );
}

